import "./bloc-logo-slider.scss";

import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

const logoSliderInit = () => {
  const sliders = document.querySelectorAll(".blocLogoSlider__slider");

  if (!sliders.length) return;

  sliders.forEach((sliderEl) => {
    new Swiper(sliderEl, {
      modules: [Autoplay],
      slidesPerView: "auto",
      spaceBetween: 40,
      loop: true,
      speed: 4000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      allowTouchMove: true,
      on: {
        beforeInit(swiper) {
          const wrapper = swiper.wrapperEl;
          const slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));

          if (!slides.length) return;

          // Avec slidesPerView:'auto', on duplique jusqu'à avoir au moins 3× les slides originales
          const minSlides = slides.length * 3;

          while (wrapper.querySelectorAll(".swiper-slide").length < minSlides) {
            slides.forEach((slide) =>
              wrapper.appendChild(slide.cloneNode(true)),
            );
          }
        },
      },
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  logoSliderInit();
});
